<template>
  <div id="interstitial" class="interstitial-scout">
    <!-- スカウトメッセージ -->
    <template v-if="tempScout.scout_data.category==1">
      <div id="inter-scout" class="scout-window">
        <div class="header-title">
          <p class="-title" v-if="tempScout.scout_data.disp_size==1">閲覧中の企業からスカウトが届いています</p>
          <p class="-title" v-else>{{widgetData.companyName}}からスカウトが届いています</p>
          <button
            class="header-close-btn mdi mdi-close"
            @click="closeScout()">
          </button>
        </div>
        <img id="inter-scout-img" class="scout-img" :src="tempScout.scout_data.store_image" v-if="tempScout.scout_data.store_image"/>
        <img id="inter-scout-img" class="scout-img" src="@/assets/scene/40.jpg" v-else/>
        <div style="height: 126px;"  v-if="!isReplyPageActive">
          <p id="inter-scout-msg" class="scout-msg" v-html="convertScoutMessage($sanitize(tempScout.scout_data.content))"></p>
          <div style="display: flex;" v-if="tempScout.scout_data.reply_type === 0">
            <input class="input is-small" v-model="seekerEmail" placeholder="Emailを入力"/>
            <button class="button is-small is-primary" @click="sendEmail()" :disabled="isSendingEmail||!seekerEmail">スカウトを受け取る</button>
          </div>
          <div v-if="tempScout.scout_data.reply_type === 1">
            <button class="button is-small is-primary is-fullwidth" @click="isReplyPageActive = true">返信する</button>
          </div>
          <div class="-footer">
            <b-checkbox
              v-model="scoutTemporaryStop">
              このブラウザではスカウト通知をしばらく表示しない
            </b-checkbox>
          </div>
        </div>
        <div style="height: 126px;" v-if="isReplyPageActive && tempScout.scout_data.reply_type === 1 && tempScout.scout_data.reply_type === 1 && !sendSeekerReplyDone">
          <div id="inter-scout-msg" class="scout-msg-reply">
            <div style="margin-right: 8px">
              <section class="reply-item">
                <p style="margin-top: 0;"><span class="required">*</span>お名前</p>
                <input v-model="seekerInfo.name" class="input is-small" type="text" placeholder="（例）田中太郎">
              </section>
              <section class="reply-item" style="margin-top: 8px;">
                <p><span class="required">*</span>Eメールアドレス</p>
                <input v-model="seekerInfo.user_email" class="input is-small" type="text" placeholder="（例）your@email.com">
              </section>
              <section class="reply-item" style="margin-top: 8px;">
                <p>返信内容</p>
                <textarea v-model="seekerInfo.reply" class="textarea is-small" style="resize: none;"></textarea>
              </section>
            </div>
          </div>
          <div class="buttons-wrapper">
            <button class="button is-small" @click="isReplyPageActive = false" style="width: 48%;">キャンセル</button>
            <button class="button is-small is-primary" style="width: 48%;" @click="sendSeekerReply()">送信</button>
          </div>
        </div>
        <div v-if="sendSeekerReplyDone">
          <div id="inter-scout-msg" class="scout-msg-reply">
            <p style="margin-top: 0;">スカウトへのご返信ありがとうございました。</p>
            <p>内容確認後、担当者よりご入力いただいたEメールアドレスにメールを送付させていただきます。</p>
            <p>今しばらくお待ちいただきますよう、何卒よろしくお願いいたします。</p>
          </div>
          <div class="sended-close-btn">
            <button class="button is-small is-primary is-fullwidth" @click="closeScoutSended()">スカウトを閉じる</button>
          </div>
        </div>
      </div>
    </template>
    <!-- 求人ノベル紹介 -->
    <template v-if="tempScout.scout_data.category==2">
      <div id="inter-novel" style="cursor: pointer; text-align: left; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
        <img style="width: 100%; height: 100%; object-fit: cover; position: absolute; z-index: 0; filter: brightness(60%) blur(0.5px);" :src="getBackgroundStory(tempStory)"/>
        <div style="height: 90px; width: -webkit-fill-available; position: absolute; bottom: 0; color: white; background: rgba(0, 0, 0, 0.4); z-index: 1; display: flex; flex-direction: column; justify-content: center;">
          <p v-if="tempScout.scout_data.content && tempScout.scout_data.content.split('¥n').length == 2 && tempScout.scout_data.content.split('¥n')[0] != ''"
          style="padding-left: 8px; font-weight: 600; font-size: smaller; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{tempScout.scout_data.content.split('¥n')[0]}}</p>
          <p v-else
          style="padding-left: 8px; font-weight: 600; font-size: smaller">求人ノベルのご紹介</p>
          <p v-if="tempScout.scout_data.content && tempScout.scout_data.content.split('¥n').length == 2 && tempScout.scout_data.content.split('¥n')[1] != ''"
          style="padding-left: 8px; font-weight: 500; font-size: small; width: calc(100% - 8px); text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{tempScout.scout_data.content.split('¥n')[1]}}</p>
          <p v-else
          style="padding-left: 8px; font-weight: 500; font-size: small; width: calc(100% - 8px); text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{widgetData.companyName}}についてより知りたい方はこちら</p>
          <p style="padding-left: 8px; font-weight: 500; font-size: small; width: calc(100% - 8px); text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{tempStory.title}}</p>
        </div>
        <a class="nobel-link" :href="getStoryURL()" @click="clickedContent()" target="_blank"></a>
        <div class="window-close-btn round mdi mdi-close mdi-24px" @click="closeScout()"></div>
      </div>
      <div class="scout-footer">
        <b-checkbox
          v-model="scoutTemporaryStop">
          このブラウザではノベル紹介をしばらく表示しない
        </b-checkbox>
      </div>
    </template>
    <!-- ロボ紹介 -->
    <template v-if="tempScout.scout_data.category==3">
      <div id="inter-novel" style="cursor: pointer; text-align: left; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
        <img style="width: 100%; height: 100%; object-fit: cover; position: absolute; z-index: 0; filter: brightness(60%) blur(0.5px);" :src="getBackgroundChatbot(tempChatbot)"/>
        <div style="height: 90px; width: -webkit-fill-available; position: absolute; bottom: 0; color: white; background: rgba(0, 0, 0, 0.4); z-index: 1; display: flex; flex-direction: column; justify-content: center;">
          <p v-if="tempScout.scout_data.content && tempScout.scout_data.content.split('¥n').length == 2 && tempScout.scout_data.content.split('¥n')[0] != ''"
          style="padding-left: 8px; font-weight: 600; font-size: smaller; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{tempScout.scout_data.content.split('¥n')[0]}}</p>
          <p v-else
          style="padding-left: 8px; font-weight: 600; font-size: smaller">ロボのご紹介</p>
          <p v-if="tempScout.scout_data.content && tempScout.scout_data.content.split('¥n').length == 2 && tempScout.scout_data.content.split('¥n')[1] != ''"
          style="padding-left: 8px; font-weight: 500; font-size: small; width: calc(100% - 8px); text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{tempScout.scout_data.content.split('¥n')[1]}}</p>
          <p v-else
          style="padding-left: 8px; font-weight: 500; font-size: small; width: calc(100% - 8px); text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{widgetData.companyName}}についてより知りたい方はこちら</p>
          <p style="padding-left: 8px; font-weight: 500; font-size: small; width: calc(100% - 8px); text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{tempChatbot.display_name}}</p>
        </div>
        <a class="nobel-link" :href="getChatbotURL()" @click="clickedContent()" target="_blank"></a>
        <div class="window-close-btn round mdi mdi-close mdi-24px" @click="closeScout()"></div>
      </div>
      <div class="scout-footer">
        <b-checkbox
          v-model="scoutTemporaryStop">
          このブラウザではロボ紹介をしばらく表示しない
        </b-checkbox>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    tempScout: {
      type: Object,
      required: true,
    },
    tempStory: {
      type: Object,
      required: false,
    },
    tempChatbot: {
      type: Object,
      required: false,
    },
    widgetData: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    isSendingEmail: {
      type: Boolean,
      required: true
    },
    sendSeekerReplyDone: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      isReplyPageActive: false,
      seekerEmail: null,
      seekerInfo: {
        seeker: '',
        name: '',
        user_email: '',
        reply: '',
        company_name: '',
        company_email: ''
      },
      scoutTemporaryStop: false,
    }
  },
  watch: {
    scoutTemporaryStop () {
      if (this.scoutTemporaryStop) {
        localStorage.setItem('SCOUT_STOP_ONEDAY', 'on')
        let dt = new Date()
        dt.setDate(dt.getDate() + 1)
        localStorage.setItem('SCOUT_STOP_TIME', dt)
        this.closeScout()
      } else {
        localStorage.setItem('SCOUT_STOP_ONEDAY', 'off')
      }
    }
  },
  methods: {
    closeScout () {
      this.$emit('closeScout')
    },
    convertScoutMessage (msg) {
      const reg = new RegExp("((https?|ftp)(://[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+))", "g")
      return msg.replace(reg, "<a style='text-decoration: underline;' href='$1' target='_blank'>$1</a>")
    },
    sendSeekerReply () {
      this.$emit('sendSeekerReply', this.seekerInfo)
    },
    sendEmail () {
      this.$emit('sendEmail', this.seekerEmail)
    },
    closeScoutSended () {
      this.$emit('closeScoutSended')
    },
    getStoryURL () {
      return process.env.OWN_ENDPOINT + '/recruits/story/' + this.data.ckey + '/' + this.tempStory.story_id
    },
    getChatbotURL () {
      return process.env.OWN_ENDPOINT + '/single/' + this.data.ckey + '/' + this.tempChatbot.bot_id
    },
    getBackgroundStory (story) {
      if (story.icon_data) {
        // オリジナル画像から使う
        return story.icon_data
      } else {
        // デフォルト画像から使う
        return require('@/assets/scene/' + story.icon_type + '.jpg')
      }
    },
    getBackgroundChatbot (bot) {
      if (bot.icon_data) {
        // オリジナル画像から使う
        return bot.icon_data
      } else {
        // デフォルト画像から使う
        return require('@/assets/template/robot.png')
      }
    },
    clickedContent () {
      this.$emit('clickedContent')
    },
  }
}
</script>

<style lang="scss" scoped>
.interstitial-scout {
  background: #FEFEFE;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 2;
  border-radius: 6px;
}
.scout-window {
  text-align: left;
  padding: 16px;
  font-size: smaller;
  width: 100%;
  height: 100%;
}
.header-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .-title {
    width: calc(100% - 30px);
    font-size: 12px;
    height: 18px;
    overflow-x: auto;
    white-space: nowrap;
  }
  .header-close-btn {
    border: none;
    cursor: pointer;
    background: transparent;
    font-size: 18px;
    margin-top: -16px;
    margin-right: -12px;
  }
}
.window-close-btn {
  border: none;
  position: absolute;
  z-index: 3;
  top: 8px;
  right: 12px;
  cursor: pointer;
  &.round {
    background: white;
    width: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
  }
}
.scout-img {
  height: 120px;
  width: 100%;
  object-fit: cover;
  margin-top: 8px;
  vertical-align: top;
}
.scout-msg {
  font-size: medium;
  overflow-y: auto;
  white-space: pre-wrap;
  margin: 8px 0;
  word-break: break-all;
}
.scout-msg-reply {
  overflow-y: auto;
  margin: 8px 0;
  word-break: break-all;
}
.buttons-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.sended-close-btn {
  margin-top: 16px;
}
.reply-item {
  p {
    font-size: small;
    margin:16px 0 4px 0;
  }
}
.required {
  color: red;
  margin-right: 2px;
}
.nobel-link {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
}
.-footer {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
}
.scout-footer {
  margin-top: 8px;
  font-size: 12px;
  color: white;
  /deep/ .check {
    border: 2px solid white !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/InterstitialScout.vue